var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"absolute":""}},[_c('div',{staticClass:"footer"},[_vm._v(" ©松尾中学校閉校記念HP 2021. All right reserved ")])])}
var staticRenderFns = []

export { render, staticRenderFns }